import {Action} from 'redux'
import {actionTypes} from './constants'

export interface ActionWithPayload<T> extends Action {
  payload?: T
}

export interface IIcardRequestsReportState {
  data?: {
    data?: any[]
    meta?: any
  }
  loading?: boolean
}

const initialState: IIcardRequestsReportState = {
  data: {data: [], meta: {}},
  loading: false,
}

export const reducer = (
  state: IIcardRequestsReportState = initialState,
  action: ActionWithPayload<IIcardRequestsReportState>
) => {
  switch (action.type) {
    case actionTypes.GET_ICARD_REQUESTS_REPORT_START:
      return {...state, loading: true}
    case actionTypes.GET_ICARD_REQUESTS_REPORT_SUCCESS:
      return {...state, data: action.payload, loading: false}
    case actionTypes.GET_ICARD_REQUESTS_REPORT_FINISH:
      return {...state, loading: false}
    default:
      return state
  }
}
